import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Finanze from "@/pages/IncassiPagamenti";
import Pulizie from "@/pages/Pulizie";
import ImportPulizie from "@/pages/ImportPulizie";
import Lavanderia from "@/pages/Lavanderia";
import Consumabili from "@/pages/Consumabili";
import Manutenzioni from "@/pages/Manutenzioni";
import Todo from "@/pages/Todo";
import Appartamenti from "@/pages/Appartamenti";
import ApartmentDetail from "@/pages/ApartmentDetail";
import Proprietari from "@/pages/Proprietari";
import Rendiconti from "@/pages/Rendiconti";
import RendicontoDetail from "@/pages/RendicontoDetail";
import Documenti from "@/pages/Documenti";
import Entrate from "@/pages/AnalisiEconomica";
import Impostazioni from "@/pages/Impostazioni";
import Recensioni from "@/pages/Recensioni";
import Preventivi from "@/pages/Preventivi";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="analisi-economica" element={<Entrate />} />
            <Route path="entrate" element={<Navigate to="/analisi-economica" replace />} />
            <Route path="impostazioni" element={<Impostazioni />} />
            <Route path="incassi-pagamenti" element={<Finanze />} />
            <Route path="finanze" element={<Navigate to="/incassi-pagamenti" replace />} />
            <Route path="pulizie" element={<Pulizie />} />
            <Route path="pulizie/importazione" element={<ImportPulizie />} />
            <Route path="lavanderia" element={<Lavanderia />} />
            <Route path="consumabili" element={<Consumabili />} />
            <Route path="manutenzioni" element={<Manutenzioni />} />
            <Route path="todo" element={<Todo />} />
            <Route path="appartamenti" element={<Appartamenti />} />
            <Route path="appartamenti/:id" element={<ApartmentDetail />} />
            <Route path="proprietari" element={<Proprietari />} />
            <Route path="rendiconti" element={<Rendiconti />} />
            <Route path="rendiconti/:id" element={<RendicontoDetail />} />
            <Route path="documenti" element={<Documenti />} />
            <Route path="recensioni" element={<Recensioni />} />
            <Route path="preventivi" element={<Preventivi />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors duration={3000} />
    </AuthProvider>
  );
}

export default App;
